// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73b31052","453":"8509665c","455":"64c61eed","977":"28c21bb1"}[chunkId] + ".chunk.js";
};